import { useIntl } from 'react-intl';
import { TextField } from '@rossum/ui/material';
import {
  getIsStartsWithTooShort,
  STARTS_WITH_OPERATOR_MIN_LENGTH,
} from '../../../mql/helpers';
import { VALUE_INPUT_WIDTH } from '../constants';
import { InputSelectorProps } from './types';

export const TextFieldInput = ({
  filterContext,
  handleFilterChange,
  autoFocus,
}: InputSelectorProps) => {
  const intl = useIntl();
  // we expect the value to be always string for this component - however the value will come from the url directly.
  // controlledValue is to restrict the 'broken' values to an empty string
  const controlledValue =
    typeof filterContext.value === 'string' ? filterContext.value : '';

  return (
    <TextField
      sx={{ width: VALUE_INPUT_WIDTH }}
      onChange={e => {
        handleFilterChange({ ...filterContext, value: e.target.value });
      }}
      autoFocus={autoFocus}
      value={controlledValue}
      size="small"
      helperText={
        getIsStartsWithTooShort(
          filterContext.value,
          filterContext.operator.value
        )
          ? intl.formatMessage(
              { id: 'containers.allDocuments.operators.minLength' },
              { minLength: STARTS_WITH_OPERATOR_MIN_LENGTH }
            )
          : ''
      }
    />
  );
};
